import React, {Component} from 'react';
import {
	Card,
	Col,
	Container,
	ListGroup,
	Modal,
	Nav,
	Row,
	Spinner,
} from 'react-bootstrap';
import './AppContent.css';
import Button from 'react-bootstrap/Button';
import Prism from 'prismjs';
import '../prism.css';
import {CopyToClipboard} from 'react-copy-to-clipboard';
import TabComponent from './TabComponent';

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {
	faCode,
	faFillDrip,
	faGlobe,
	faImage,
	faAlignCenter,
} from '@fortawesome/free-solid-svg-icons';
import {FormattedMessage, injectIntl} from 'react-intl';
import {connect} from 'react-redux';

import tRegistry from './templates/templatesRegistry';
import {toast} from 'react-toastify';
import {Steps} from 'intro.js-react';

import 'intro.js/introjs.css';

import {LanguageWeb, toggleTour} from '../Redux/action';

const pretty = require('pretty');

let windowSize = '400px';

/**
 * Tour
 ************************/

/********END TOUR********/
class AppContent extends Component {

	componentDidMount() {
		Prism.highlightAll();
	}

	constructor(props) {
		super(props);

		this.state = {
			show: false,
			showGenerateSignatureModal: false,
			image: false,
			html: false,
			rich: false,
			generatedHtml: '',
			generatedImg: '',
			generatedImageIsReady: false,
			copied: false,
			bothLanguage: false,
			language: 'العربية',
			count: 1,
			signatureTemplate: tRegistry[0],
		};

		windowSize = document.querySelector('html').clientHeight - (300) + 'px';

	}

	handleCopyHtml = () => {
		setTimeout(() => {
			this.setState({copied: false});
		}, 2000);
	};

	handleClose = () => {
		this.setState({show: false});
		this.setState({showGenerateSignatureModal: false});
		this.setState({
			image: false,
			html: false,
			rich: false,
			generatedImg: '',
			generatedHtml: '',
			generatedImageIsReady: false,

		});
	};

	handleShow = () => {
		this.setState({show: true});
	};

	handleFinish = () => {
		this.setState(
				{generatedHtml: pretty(document.querySelector('#toCopy').innerHTML)});
		this.setState({showGenerateSignatureModal: true});
	};

	getGeneratedImage = () => {
		const htmlToImage = require('html-to-image');
		const parent = this;
		
		// Find the signature root element using data attribute
		const node = document.querySelector('[data-signature-root="true"]');
		
		if (!node) {
			toast.error(parent.props.intl.formatMessage({id: 'alert.image-generated-fail'}));
			return;
		}
		
		// Use the computed style to get the actual width from CSS
		const computedStyle = window.getComputedStyle(node);
		const width = parseInt(computedStyle.width, 10);
		const height = Math.ceil(node.scrollHeight);
		
		htmlToImage.toPng(node, {
			width: width,
			height: height,
			pixelRatio: 1,
			cacheBust: true,
			backgroundColor: '#ffffff',
		}).then(function(dataUrl) {
			parent.setState({
				generatedImg: dataUrl,
				generatedImageIsReady: true,
			});
			// toast.success(parent.props.intl.formatMessage({id: "alert.image-generated-success"}))
		}).catch(function(error) {
			toast.error(parent.props.intl.formatMessage({id: 'alert.image-generated-fail'}));
		});
	};

	handleGenerateToggle = (element) => {

		const {id} = element.currentTarget;
		const toggles = ['image', 'rich', 'html'];

		if (toggles.includes(id)) {
			this.setState({[id]: true});

			if (id === 'image') {
				this.getGeneratedImage();
			}

			const parent = this;
			toggles.forEach(function(value) {
				if (value !== id) {
					parent.setState({[value]: false});
				}
			});
		}
	};

	handleFormLanguage = () => {
		if (this.props.language_web === 'English') {
			return (this.props.language_web_m('العربية'));
		} else if (this.props.language_web === 'العربية') {
			return (this.props.language_web_m('English'));
		}
	};
	TitleShow = () => {
		switch (this.state.count) {
			case 1:
				return (this.props.language_web);
			case 2:
				return null;
			case 3:
				return (<FormattedMessage id="content.logo"/>);
			default:
		}
	};

	handleSwitchNext = () => {
		const {count} = this.state;
		if (count < 3) {
			this.setState({
				count: count + 1,
			});
		}
	};

	handleSwitchPrevious = () => {
		const {count} = this.state;
		if (count > 1) {
			this.setState({
				count: count - 1,
			});
		}
	};

	handleSwitchTemplate = (e) => {
		this.setState({
			signatureTemplate: tRegistry[e.target.getAttribute('data-index')],
			show: false,
		});
	};

	render() {
		const step = [
			{
				element: '#sectionSettings',
				intro: this.props.intl.formatMessage({id: 'tour.sectionSettings'}),
				position: 'right',
			},
			{
				element: '#buttonSettingsNext',
				intro: this.props.intl.formatMessage({id: 'tour.buttonSettingsNext'}),
				position: 'right',
			},
			{
				element: '#settingsChangeLanguageButton',
				intro: this.props.intl.formatMessage({id: 'tour.settingsChangeLanguageButton'}),
				position: 'left',
			},
			{
				element: '#SectionPreview',
				intro: this.props.intl.formatMessage({id: 'tour.sectionPreview'}),
				position: 'bottom',
			},
			{
				element: '#toCopy',
				intro: this.props.intl.formatMessage({id: 'tour.toCopy'}),
				position: 'bottom',
			},
			{
				element: '#buttonTemplates',
				intro: this.props.intl.formatMessage({id: 'tour.buttonTemplates'}),
				position: 'left',
			},
			{
				element: '#buttonFinish',
				intro: this.props.intl.formatMessage({id: 'tour.buttonFinish'}),
				position: 'right',
			},

		];

		const SignatureTemplate = this.state.signatureTemplate.ltr;
		const SignatureTemplateRTL = this.state.signatureTemplate.rtl;
		return (

				<section id="app-content" className="mt-4 mb-4 flex-shrink-0">

					<Steps
							enabled={this.props.tour}
							steps={step}
							initialStep={0}
							onExit={() => {this.props.toggleTour(false);}}
							options={
								{
									nextLabel: this.props.intl.formatMessage({id: 'label.next'}),
									prevLabel: this.props.intl.formatMessage({id: 'label.prev'}),
									skipLabel: this.props.intl.formatMessage({id: 'label.skip'}),
									doneLabel: this.props.intl.formatMessage({id: 'label.end-tour'}),
									hideNext: true,
									showProgress: true,
								}
							}

					/>
						<div className='content-container'>
					<Container>
							<Row>
								<Col lg="5" className="mb-2 form-container" id="sectionSettings">
									<Card>
										<Card.Header>
											<div className='d-flex justify-content-between w-100'>
													{(this.state.count < 2) &&
													<Button className="general-btn" onClick={this.handleSwitchNext} id="buttonSettingsNext">
														<FormattedMessage id="content.general.advanced"/>
													</Button>}
													{(this.state.count > 1) &&
													<Button className="general-btn" onClick={this.handleSwitchPrevious}>
														<FormattedMessage id="content.general.back"/>
													</Button>}
												
													{this.state.count === 1 ?
													<Nav.Link className="card-lang-btn" variant="outline-dark" onClick={this.handleFormLanguage} id="settingsChangeLanguageButton">
														<FontAwesomeIcon icon={faGlobe}/> &nbsp;
														<FormattedMessage id="content.general.data"/>
													</Nav.Link>
													:
													<div className="float-right font-weight-bold"> {this.TitleShow()}</div>}
											</div>
										</Card.Header>
										<Card.Body>
											<TabComponent count={this.state.count}/>

											<div className='btns-container'>
												

												
												<Button className="general-btn" variant="info" onClick={this.handleShow} id="buttonTemplates">
													<FontAwesomeIcon icon={faFillDrip}/> &nbsp;
													<FormattedMessage id="content.templates"/>
												</Button>
												<Button className="general-btn" variant="info" onClick={this.handleFinish} id="buttonFinish">
													<FormattedMessage id="content.finish"/>
												</Button>
											</div>


										</Card.Body>

									</Card>

								</Col>
								<Col lg="7" className='card-content'>
									<Card id="SectionPreview">

										<ListGroup variant="flush">
											<div className="preview-dummy">
												<ListGroup.Item>
													{<br/>}
													{/* <FormattedMessage id="content.sample"/> */}
													{/*Signature App_Content*/}

													<div className="mt-5" id="toCopy">
														{this.props.language_web === 'English' &&

														<div style={{
															direction: 'ltr',
															textAlign: 'left',
															overflowX: 'auto',
															overflowY: 'hidden'

														}}><SignatureTemplate/></div>
														}
														{this.props.language_web === 'العربية' &&

														<div style={{
															direction: 'rtl',
															overflowX: 'auto',
															overflowY: 'hidden',
														}}>
															<SignatureTemplateRTL/>
														</div>}

													</div>

												</ListGroup.Item>
											</div>
										</ListGroup>
									</Card>
								</Col>
							</Row>
					</Container>
						</div>

					{/*	Template Modal */}
					<Modal size="lg" show={this.state.show} onHide={this.handleClose}>
						<Modal.Header closeButton>
							<Modal.Title><FormattedMessage id="content.templates"/></Modal.Title>
						</Modal.Header>
						<Modal.Body style={{height: windowSize, overflowY: 'auto', backgroundColor: '#f5f5f5'}}>
							{this.props.language_web === 'English' && tRegistry.map((item, index) => {
								let CurrentTemplate = item.ltr;
								return (
										<div className="template-grandparent" key={index}>
											<div className='template-parent' style={{overflowX: 'auto', direction: 'ltr'}}>
												<div className="template-preview mb-3" style={{width: '600px', minWidth: '-webkit-fill-available'}} data-index={index} key={index} onClick={this.handleSwitchTemplate}>
													<CurrentTemplate/>
												</div>
												<div className="title-right" style={{Right: '0'}}>{item.name}</div>
											</div>
										</div>);
							})}
							{this.props.language_web === 'العربية' && tRegistry.map((item, index) => {
								let CurrentTemplate = item.rtl;
								return (
										<div className="template-grandparent" key={index}>
											<div className='template-parent' style={{overflowX: 'auto', direction: 'rtl'}}>
												<div className="template-preview mb-3" style={{width: '600px', minWidth: '-webkit-fill-available'}} data-index={index} key={index} onClick={this.handleSwitchTemplate}>
													<CurrentTemplate/>
												</div>
												<div className="title">{item.name}</div>
											</div>
										</div>);
							})}
						</Modal.Body>
					</Modal>


					{/* Generate Signature Modal */}
					<Modal size="lg" show={this.state.showGenerateSignatureModal} onHide={this.handleClose}>
						<Modal.Header closeButton>
							<Modal.Title><FormattedMessage id="modal.title.generate-signature"/></Modal.Title>
						</Modal.Header>

						<Modal.Body>
							<Row>
								<Col lg={12}>

									{/*Dis is TEXT*/}
									{!(this.state.image || this.state.html) &&
									<div style={{border: '1px solid #d4d1d1', height: '100%'}}>
										<div className="language-markup" id="copyRichTextLayout" style={{padding: '10px'}}>
											{this.props.language_web === 'English' &&
											<div style={{
												direction: 'ltr',
												textAlign: 'left',
												overflowX: 'auto',
												overflowY: 'hidden',
											}}><SignatureTemplate/></div>
											}
											{this.props.language_web === 'العربية' &&
											<div style={{direction: 'rtl', overflowX: 'auto', overflowY: 'hidden'}}>
												<SignatureTemplateRTL/>
											</div>}
										</div>

									</div>}

									<div style={(this.state.image) ? {display: 'block'} : {display: 'none'}}>

										<img style={(this.state.generatedImageIsReady) ? {display: 'block', maxHeight: '300px', width: 'auto', margin: '0 auto'} : {display: 'none'}} alt="Signature" id="imageSignature" src={this.state.generatedImg}/>
										{(!this.state.generatedImageIsReady) &&
										<Spinner animation="grow" variant="info"/>}
									</div>

									<div style={(this.state.html) ? {display: 'block'} : {display: 'none'}}>

										<div className="d-none">
											{this.state.copied && toast.success(this.props.intl.formatMessage({id: 'alert.copied'}))}
										</div>

										<pre className="language-markup" style={{height: '300px'}}>
											<code id="HtmlCode">
												{this.state.generatedHtml}
											</code>
										</pre>
									</div>

								</Col>
							</Row>
						</Modal.Body>
						<Modal.Footer>
							<Row style={{width: '-webkit-fill-available'}}>
								<Col lg={6}>

									<Button id="rich" className="general-btn mx-2" onClick={this.handleGenerateToggle}><FontAwesomeIcon icon={faAlignCenter}/>&nbsp;
										<FormattedMessage id="content.text" defaultMessage="TEXT"/>
									</Button>
									<Button id="image" className="general-btn mx-2" onClick={this.handleGenerateToggle}><FontAwesomeIcon icon={faImage}/>&nbsp;
										<FormattedMessage id="content.png" defaultMessage="PNG"/>
									</Button>
									<Button id="html" className="general-btn mx-2" onClick={this.handleGenerateToggle}><FontAwesomeIcon icon={faCode}/>&nbsp;
										<FormattedMessage id="content.HTML" defaultMessage="HTML"/>
									</Button>

								</Col>

								<Col lg={6}>
									{/*copy as text*/}
									{this.state.rich &&
									<Button className='general-btn float-right animated jackInTheBox' data-clipboard-action="copy" data-clipboard-target="#copyRichTextLayout" onClick={() => toast.success(this.props.intl.formatMessage({id: 'alert.copied'}))}>
										<FormattedMessage id="modal.copy"/></Button>}

									{/* Download */}
									{this.state.image &&
									<a className="float-right animated jackInTheBox" href={this.state.generatedImg} download="yoursignature.png"
									><Button className="general-btn"><FormattedMessage id="modal.download"/></Button></a>
									}

									{/* Copy HTML */}
									{this.state.html &&
									<CopyToClipboard text={this.state.generatedHtml} onCopy={() => this.setState(
											{copied: true})}>
										<Button onClick={this.handleCopyHtml} className="float-right general-btn animated jackInTheBox"><FormattedMessage id="modal.copy-html"/></Button>
									</CopyToClipboard>}
								</Col>
							</Row>
						</Modal.Footer>
					</Modal>


				</section>);
	}
}

function mapStateToProps(state) {
	return {
		language: state.TranslationReducer.language,
		language_web: state.LanguageReducer.languageWeb,
		tour: state.TourReducer.isStarted,
	};
}

function mapDispatchToProps(dispatch) {
	return {
		toggleTour: (the_state) => dispatch(toggleTour(the_state)),
		language_web_m: (lang) => dispatch(LanguageWeb(lang)),
	};
}

export default connect(mapStateToProps, mapDispatchToProps)((injectIntl(AppContent)));
